import React, { useEffect } from "react";
import "./Free_checkup.css";
import Explore_btn from "../../common-components/common-buttons/explore-button/Explore_btn";
import Book_appointment_modal from "../../common-components/common-modals/book-appointment-modal/Book_appointment_modal";
import { useDispatch, useSelector } from "react-redux";
import { getCheckupBanner, getOfferBanner } from "../../../features/home/homeSlice";

const Free_checkup = () => {
  const [modalShow, setModalShow] = React.useState(false);

  const dispatch = useDispatch();

  const allbanners = useSelector((state) => state.home.checkupbanners);
  useEffect(() => {
    dispatch(getCheckupBanner({ banner_type_id: 2 }));
  }, []);
  return (
    <>
      <section className="Free_checkup_sec">
        <div className="container">
          <div className="innersec">

             <div className="leftsec">
              <img
                className="eychecup"
                src={
                  process.env.REACT_APP_IMAGE_URL +
                  allbanners?.image
                }
                alt="eye-checkup"
              />
            </div>
            {/* <div className="leftsec">
              <img
                className="eychecup"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/free-eye-checkup/eye-checkup.png"
                }
                alt="eye-checkup"
              />
            </div> */}
            <div className="rightsec">
              <img
                className="benfitbanner"
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/home/free-eye-checkup/benifit.png"
                }
              />
              <Explore_btn
                name={"Book Your Appointment Now"}
                onClick={() => setModalShow(true)}
              />
            </div>
          </div>
        </div>
      </section>

      <Book_appointment_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Free_checkup;
